/** A 6 digit representation of the BSB. */
export type BSBSixDigit = string;
/** The mnemonic for the BSB's financial institution. */
export type BSBMnemonic = string;
/** The name of the BSB. */
export type BSBName = string;
/** A 3 element Tuple containing the six digit BSB, bank mnemonic, and bsb name. */
export type BSBEntry = [BSBSixDigit, BSBMnemonic, BSBName];

declare global {
  interface Window {
    AusPayNetBsbs?: BSBEntry[];
  }
}

function getNodeAusPaymentsNetworkBsbs(): BSBEntry[] {
  return [];
}

function getBrowserAusPaymentsNetworkBsbs(): BSBEntry[] {
  return window.AusPayNetBsbs || [];
}

export function getAusPaymentsNetworkBsbs(): BSBEntry[] {
  return typeof window === "undefined"
    ? getNodeAusPaymentsNetworkBsbs()
    : getBrowserAusPaymentsNetworkBsbs();
}

export function normaliseBsb(bsb: string | null): string {
  return (bsb || "").replace(/[^\d]/g, "");
}
